import 'react';
import { LinkIcon } from 'reaxl';
import { jsx } from 'react/jsx-runtime';
function LendingOptionsCTA(_ref) {
  let {
    enableMyWallet,
    callback = () => {},
    label = 'Explore Financing',
    cmp = 'explr-fin',
    href = '',
    glyph = 'chevron-right',
    target = '_blank',
    rel = 'nofollow noopener',
    className = 'margin-horizontal-2 text-nowrap margin-top-2'
  } = _ref;
  const handleClick = event => {
    enableMyWallet(event);
    callback(event);
  };
  return /*#__PURE__*/jsx(LinkIcon, {
    className: className,
    "data-cmp": `lnk-lnd-opt-${cmp}`,
    placement: "after",
    glyph: glyph,
    onClick: handleClick,
    undecorated: true,
    ...(href && {
      href,
      target,
      rel
    }),
    children: label
  });
}
export { LendingOptionsCTA as default };
